import API, { graphqlOperation } from "@aws-amplify/api";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const getGenerationConfig = () =>
  makeGraphQLRequest(graphqlOperation(queries.listGenerationConfigs));

export default {
  getGenerationConfig,
};
